/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_1_P1Inputs */



/**
* | output |
* | --- |
* | "The Guardrails feature is a rule-based filtering system that analyzes incoming user requests (prompts) using configurable regex pattern templates. When a mat..." |
*
* @param {Guardrails_Section_1_P1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_1_p1 = /** @type {((inputs?: Guardrails_Section_1_P1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_1_P1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Guardrails-Funktion ist ein regelbasiertes Filtersystem, das eingehende Benutzeranfragen (Prompts) anhand von konfigurierbaren Regex-Pattern-Templates analysiert. Bei Übereinstimmung mit einem definierten Muster wird die Anfrage blockiert und ein Audit-Log-Eintrag erstellt.")
	return /** @type {LocalizedString} */ ("The Guardrails feature is a rule-based filtering system that analyzes incoming user requests (prompts) using configurable regex pattern templates. When a match is detected, the request is blocked and an audit log entry is created.")
});